<template>
    <SectionBase :section="section">
        <div
            v-for="({ module, column }, index) in visibleModules()"
            class="col"
            :style="columnSettings(module)"
            :class="[verticalAlignment()]"
        >

            <div class="ufo--column">
                <div v-if="section.contentSettings?.showMedia && column" class="media-container" :style="mediaAspectRatio(module.gridSettings.mediaAspectRatio, column.media.mockupSettings)">
                    <ColumnImageHelper
                        :index="index"
                        :total-columns="section.columns.length"
                        :section="section"
                        :column-media="column.media"
                        :placeholder-image="`${isCaseStudy ? '' : 'portfolio-'}empty-columns-0${index+1}.${isCaseStudy ? 'jpg' : 'png'}`"
                    />
                </div>

                <SectionText
                    v-if="section.contentSettings?.showText !== false && column"
                    :text-index="index"
                    :total-columns="section.columns.length"
                    :section-text="column.text"
                />

            </div>

        </div>
    </SectionBase>
</template>

<script>
    import {updateSectionLevelColorCssInHead} from "@/scripts/common/TextStyleRenderHelper.js";
    import {SectionModuleTypeEnum} from "@/scripts/common/enums.js";
    import { resolveRowSpan } from "@/scripts/common/utilities/layout.js";
    import ColumnImageHelper from "./_helper/ColumnImageHelper.vue";
    import SectionText from "./_helper/GetSectionText.vue";
    import SectionBase from "@/scripts/view/portfolio/sections/SectionBase.vue";

    export default {
        name: "Columns",
        props:['section'],
        components: {
            SectionBase,
            SectionText,
            ColumnImageHelper
        },
        beforeMount() {
            updateSectionLevelColorCssInHead(this.section)
        },
        computed: {
            isCaseStudy() {
                return this.$store.getters.isCaseStudy
            },
            sectionColumns() {
                const columns = Array.isArray(this.section?.columns) ? this.section.columns : [];
                return columns.map((column) => {
                    if (!column || column.columnId) return column;
                    return {
                        ...column,
                        columnId: column.id || column._id || null
                    };
                });
            }
        },
        methods: {
            visibleModules() {
                const modules = this.section.layoutSettings?.modules || [];
                return modules
                    .map((module, index) => ({ module, index }))
                    .filter(({ module }) => module.type !== SectionModuleTypeEnum.SPACER)
                    .map(({ module, index }) => ({
                        module,
                        column: this.getColumnByModule(module, index)
                    }));
            },
            getColumnIdFromModule(module, columnIndex) {
                if (!module) return null;
                if (module.referencedColumnId) return module.referencedColumnId;
                if (module.columnId) return module.columnId;
                const fallbackColumn =
                    typeof columnIndex === "number" && columnIndex >= 0
                        ? this.sectionColumns[columnIndex]
                        : null;
                if (fallbackColumn?.columnId) {
                    return fallbackColumn.columnId;
                }
                return module.moduleId;
            },
            getColumnByModule(module, moduleIndex) {
                if (!module) return null;
                const columnIndex = this.getColumnIndex(moduleIndex);
                const columnId = this.getColumnIdFromModule(module, columnIndex);
                if (columnId) {
                    const matched = this.sectionColumns.find((col) => col.columnId === columnId);
                    if (matched) return matched;
                }

                return columnIndex >= 0 ? this.sectionColumns[columnIndex] : null;
            },
            getColumnIndex(moduleIndex) {
                const modules = this.section.layoutSettings?.modules || [];
                let columnIndex = 0;

                for (let i = 0; i < moduleIndex; i++) {
                    if (modules[i]?.type === SectionModuleTypeEnum.COLUMN) columnIndex++;
                }

                const currentModule = modules[moduleIndex];
                return currentModule?.type === SectionModuleTypeEnum.COLUMN
                    ? columnIndex
                    : -1;
            },
            columnSettings(module) {
                const { rowStart, rowEnd } = resolveRowSpan(module.gridSettings);
                return {
                    '--columnStart': module.gridSettings?.columnStart,
                    '--columnEnd': module.gridSettings?.columnEnd,
                    '--rowStart': rowStart,
                    '--rowEnd': rowEnd,
                    '--height': module.gridSettings?.height ? `${module.gridSettings?.height}px` : null,
                    '--mediaHeight': module.gridSettings?.mediaHeight ? `${module.gridSettings?.mediaHeight}px` : null
                }
            },
            verticalAlignment() {
                return `aligned-${this.section.styleSettings && this.section.styleSettings?.boxAlign && this.section.styleSettings?.boxAlign.split('-')[1] || 'middle'}`
            },
            mediaAspectRatio(mediaAr, mockupSettings) {
                return {'--mediaAspectRatio': mediaAr && !mockupSettings ? `${mediaAr[0]} / ${mediaAr[1]}` : null}
            }
        }
    }
</script>
